import React from 'react';
import { NavLink } from 'react-router-dom';

export const UserOrdersBreadcrumb = () => {
    return (
        <nav aria-label="breadcrumb">
            <div className="breadcrumb">
                <NavLink className="breadcrumb-item text-decoration-none" to="/">
                    Home
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/user">
                    User
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/user/orders">
                    Orders
                </NavLink>
            </div>
        </nav>
    );
};
